import * as t from "react";
import { useKnockClient as m } from "../../core/context/KnockProvider.mjs";
import "@knocklabs/client";
import "fast-deep-equal";
import { feedProviderKey as u } from "../../core/utils.mjs";
import k from "../hooks/useNotifications.mjs";
import { useCreateNotificationStore as a } from "../hooks/useNotificationStore.mjs";
const i = t.createContext(void 0), F = ({
  feedId: e,
  children: c,
  defaultFeedOptions: r = {},
  colorMode: s = "light"
}) => {
  let o;
  try {
    o = m();
  } catch {
    throw new Error("KnockFeedProvider must be used within a KnockProvider.");
  }
  const n = k(o, e ?? "", r), d = a(n);
  return /* @__PURE__ */ t.createElement(i.Provider, { key: u(o.userId, e ?? "", r), value: {
    knock: o,
    feedClient: n,
    useFeedStore: d,
    colorMode: s
  } }, c);
}, P = () => {
  const e = t.useContext(i);
  if (!e)
    throw new Error("useKnockFeed must be used within a KnockFeedProvider");
  return e;
};
export {
  F as KnockFeedProvider,
  P as useKnockFeed
};
//# sourceMappingURL=KnockFeedProvider.mjs.map
